import type { ReactNode } from 'react';

export function HelpText({ children }: { children: ReactNode }) {
  return <p className="text-xs text-slate-500">{children}</p>;
}

export function PageHint({ children }: { children: ReactNode }) {
  return (
    <p className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600">
      💡 {children}
    </p>
  );
}
